module.exports = __webpack_public_path__ + "img/podvesnaya_40.d69a86da.svg";